import { defaultColumns, defaultSort } from '../../components/data/products/products/columns';

export default {
  state: {
    products: [],
    loading: false,
    tableConfig: null,
    currentPage: 1,
    filterString: null,
    palletDefaultSupplier: null,
    palletDefaultExpirationDate: null,
    defaultProductDataLoading: false,
    sorting: {
      prop: 'name',
      order: 'ascending',
    },
  },
  getters: {
    products: state => state.products,
    loading: state => state.loading,
    tableConfig: state => state.tableConfig,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
    palletDefaultSupplier: state => state.palletDefaultSupplier,
    palletDefaultExpirationDate: state => state.palletDefaultExpirationDate,
    defaultProductDataLoading: state => state.defaultProductDataLoading,
  },
  mutations: {
    setProducts(state, products) {
      state.products = products;
    },
    setLoading(state, display) {
      state.loading = display;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },

    setPalletDefaultSupplier(state, palletDefaultSupplier) {
      state.palletDefaultSupplier = palletDefaultSupplier;
    },
    setPalletDefaultExpirationDate(state, palletDefaultExpirationDate) {
      state.palletDefaultExpirationDate = palletDefaultExpirationDate;
    },
    setDefaultProductDataLoading(state, isLoading) {
      state.defaultProductDataLoading = isLoading
    }
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/product-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'product-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'product-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAllWithPagination({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const products = await axios.get('api/products-pagination' + (query || ''));
        commit('setProducts', products);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const products = await axios.get('api/products-all');
        commit('setProducts', products);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchBySupplierId({ commit }, $id) {
      return await axios.get('api/products/supplier/' + $id);
    },

    async fetchBySupplierOrderId({ commit }, $id) {
      return await axios.get('api/products/supplier-order/' + $id);
    },

    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/products/search' + (queryString || ''));
      } catch (e) {
      }
    },

    async searchWithoutPackType({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/products/search-without-pack-type' + (queryString || ''));
      } catch (e) {
      }
    },

    async getPackTypes({ commit, state, dispatch }, productId) {
      try {
        return await axios.get(`api/products/${productId}/pack-types`);
      } catch (e) {
      }
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/products/' + id);
      } catch (e) {
      }
    },

    async create({ commit }, payLoad) {
       return await axios.post('api/products', payLoad);
    },

    async update({ commit }, payLoad) {
       return await axios.put('api/products', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/products/' + id);
    },

    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/product-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'Products'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },

    async getDefaultProductData({ commit }) {
      commit('setDefaultProductDataLoading', true)
      try {
        const response = await axios.get('api/product/default-data');
        commit('setPalletDefaultSupplier', response.pallet_supplier);
        commit('setPalletDefaultExpirationDate', response.pallet_expiration_date);
      } catch (e) {}
      commit('setDefaultProductDataLoading', false)
    }
  },
};
